import { baseball } from './baseball'
import { basketball } from './basketball'
import { hockey } from './hockey'
import { rugby } from './rugby'

export const greek = {
  baseball,
  basketball,
  hockey,
  rugby
}